import { customizeSearch, createCustomToggle } from '../js/utils/helpers';
import { modifyFeatureLineup } from '../js/components/featureLineup';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  customizeSearch();
  createCustomToggle();
  updateContentMargin();
  modifyFeatureLineup();
});

// ****************************************************************************************************************************************************
// Function to calculate content margin top

function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight() || 0;
    const topBanner = $('.top-banner');
    const content = $('.content');
    const isMobile = globalThis.matchMedia('(max-width: 1100px)').matches;

    // Homepages
    if ($('body').is('.homepage, .ese-foundation-home, .fiber-fest-home')) {
      content.css('margin-top', headerHeight);
      return;
    }

    // Inner Pages
    if (topBanner.length) {
      // with top banner
      topBanner.css('margin-top', headerHeight);

      let contentMargin;

      if ($('body').hasClass('ese-foundation') || $('body').hasClass('fiber-fest')) {
        contentMargin = 0;
      } else if (isMobile) {
        contentMargin = headerHeight + topBanner.outerHeight();
      } else {
        contentMargin = headerHeight + (globalThis.innerWidth / 1600) * 215;
      }

      content.css('margin-top', contentMargin);
    } else {
      // without top banner
      content.css('margin-top', headerHeight + (isMobile ? 20 : 30));
    }
  }

  applyMargin();
  $(globalThis).on('resize scroll', applyMargin);
  new ResizeObserver(applyMargin).observe(document.querySelector('header'));
}
